import { render, staticRenderFns } from "./choose-folder-dialog.vue?vue&type=template&id=08f22020&"
import script from "./choose-folder-dialog.vue?vue&type=script&lang=js&"
export * from "./choose-folder-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports